/**
 * Shared section shell classes — keep marketing / home rhythm in sync (`styles/base/page-sections.css`).
 */

/** Primary hero (home + hub + category + leaf marketing pages). */
export const PAGE_HERO_BAND_CLASS =
  'container-section page-section-band page-section-band--accent page-hero-band';

/** Home hero has no breadcrumb bar above — keep top breathing room below the navbar. */
export const PAGE_HERO_BAND_HOME_CLASS = `${PAGE_HERO_BAND_CLASS} mt-10`;

export const PAGE_SECTION_BAND_MUTED = 'page-section-band page-section-band--muted';

export const PAGE_SECTION_BAND_ELEVATED = 'page-section-band page-section-band--elevated';

export const PAGE_SECTION_BAND_ACCENT = 'page-section-band page-section-band--accent';

export function pageSectionShell(...bands: string[]): string {
  return ['container-section', ...bands].filter(Boolean).join(' ');
}
